<template>
  <span>{{ down }}</span>
</template>
<script>
export default {
  props: {
    second: {
      type: Number,
      default: 30
    }
  },
  data () {
    return {
      down: this.second
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    init () {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.down--
        if (this.down === 0) {
          clearInterval(this.timer)
          this.$emit('end')
        }
      }, 1000)
    },
    reset () {
      this.down = this.second
      this.init()
    },
  },
}
</script>
